<template>
	<div class="page-container">
		<HeaderLayout></HeaderLayout>
		<div class="content">
		     <div class="main-content">
			       <div class="main-1">
				   		 <h3 class="text-name">{{boardName}}</h3>
						 <div class="box-a">
						       <p class="text">{{info.subject}}</p>
							   <p class="text-1"><span class="name-a">등록일</span>{{rdate}}<span class="name">조화수</span>{{info.hit}}</p>
						 </div>
						 <div class="box-b"  style='text-align:left;' v-html="info.contents">
						 </div>
						 <div class="imgList" v-if="imgList.length>0">
							<ul>
								<li v-for="img in imgList">
									<img :src="$VARS.url+img">
								</li>
							</ul>
						 </div>

						 <div style='margin:30px 0;background:#fafafa;padding:30px;'  v-if="info.bid=='question' && info.summary">
							<div class="subject-box">
								<div class="subject" style='font-weight:bold;padding:30px 0 20px 0;font-size:12pt;'>답변내용</div>
							</div>
							
							<div style='text-align:left;' v-html="info.summary">
							</div>
						</div>
						 <div class="box-list" v-if="preInfo.no && nextInfo.no">
						    <ul>
								<li v-if="preInfo.no" @click="getView(preInfo.no)">
									<span class="text-black"> 이전글</span> {{preInfo.subject}}
								</li>	
								<li  v-if="nextInfo.no"  @click="getView(nextInfo.no)">
									<span class="text-black">다음글</span> {{nextInfo.subject}}
								</li>	
							</ul>
						 </div>
						 <div class="box-button" @click="$router.go(-1)">
						 		목록으로
						 </div>
				   </div>
			 </div>
		</div>
			
		<FooterLayout></FooterLayout>
	</div>
</template>

<script>
import HeaderLayout from '@/components/inc/Header'
import FooterLayout from '@/components/inc/Footer'


export default {
	name: 'BoardView',
	components: {
		HeaderLayout,
		FooterLayout
	},
	data () {
		return {
			boardName:'',
			info:{},
			rdate:'',
			imgList:[],
			preInfo:{},
			nextInfo:{},
		}	
	},
	created: function() {
		var no = this.$route.params.no;
		this.getData(no);
	},
	methods: {
		getData(no) {
			var params = {no:no};
			var obj = this;
			this.$form.sendPost(params,'boardApp/getView',function(resp) {
				
				obj.boardName = resp.board_info.name;
				obj.info = resp.info;
				obj.rdate = obj.info.rdate.substr(0,10).replace('-','.').replace('-','.');
				if(resp.preInfo)obj.preInfo = resp.preInfo;
				else obj.preInfo = {};
				if(resp.nextInfo)obj.nextInfo = resp.nextInfo;
				else obj.nextInfo = {};
				
				if(resp.info.dfiles) {
					obj.imgList = resp.info.dfiles;
			
				}

				//obj.boardList = resp.datas.datas;
				

			});
		},
		getView(no) {
			this.getData(no);
	   }
	
	},
	mounted: function() {

	 }

}
</script>

<style lang="scss" scoped>
.page-container {
	background:#fff;
	padding:0;
	margin:0;
	min-height:calc(100vh);
	.content         {
		   				width:100%;
						height:auto;
					    padding:130px 0 10px; 
						font-family: 'Nanum Gothic', sans-serif;
						background:#fff;
					    .main-content             {
						  				width:851px;
										margin:0 auto;
										.main-1        {
									              .text-name        {
										          			font-size:18px;
										          			color:#3F3F3F;
										          }
												  .imgList {
													margin:10px 0;
													width:100%;
													ul {
														display:flex;
														flex-wrap:wrap;
														li {
															width:45%;
															margin:10px;
															img {
																width:100%;
															}
														}
													}
												  }
												  .box-a         {
												  			width:100%;
															height:110px;
															border-top:1px solid #3D79FE;
															border-bottom:1px solid #B2B2B2;
															margin-top:20px;
															padding:20px 25px;
															.text        {
																	font-size:20px;
										          			        color:#000;
																    font-weight:bold;
															}
															.text-1         {
															           margin-top:32px;
																	   color:#B7B7B7;
																	   font-size:12px;
															          .name   {
																	  		color:#3D79FE;
																			margin:0 10px;
																      }
																	  .name-a    {
																	  		margin-right:10px;
																			color:#3D79FE;
																	  }
															}
												  }
												  .box-b         {
												  			width:100%;
															min-height:300px;
															text-align:center;
															line-height:120%;
														    color:#000;
															font-size:20px;
															padding:20px;
												  }
												  .box-list       {
												  			width:100%;
															height:90px;
															border-top:1px solid #ECECEC;
															border-bottom:1px solid  #ECECEC;
															padding:10px 25px;
															ul       {
															      li       {
																           font-size:11pt;
																		   color:#7C7C7C;
																		   margin-top:10px;
																		   cursor:pointer;
																		   .text-black       {
																		   				color:#000;
																						margin-right:10px;
																						font-weight:bold;
																	       
																		   }
																  }
															}
												  }
												  .box-button     {
												  			width:220px;
															height:50px;
															margin:50px auto;
															border:1px solid #B2B2B2;
															text-align:center;
															line-height:50px;
															font-size:12px;
															color:#000;
															cursor:pointer;
												  }
										}
						}
		   }
	
}
</style>